import { Skeleton } from "@offstreetparking/design-system/feedback";

export const PaymentFormSkeleton = () => (
	<div className="space-y-4">
		{/* Card number field skeleton */}
		<div className="space-y-2">
			<Skeleton className="h-4 w-24" />
			<div className="relative">
				<Skeleton className="h-12 w-full" />
				{/* Card brand icons skeleton */}
				<div className="-translate-y-1/2 absolute top-1/2 right-3 flex gap-1">
					<Skeleton className="h-6 w-8" />
					<Skeleton className="h-6 w-8" />
					<Skeleton className="h-6 w-8" />
					<Skeleton className="h-6 w-8" />
				</div>
			</div>
		</div>

		{/* Expiry and CVC fields skeleton */}
		<div className="grid grid-cols-2 gap-4">
			<div className="space-y-2">
				<Skeleton className="h-4 w-24" />
				<Skeleton className="h-12 w-full" />
			</div>
			<div className="space-y-2">
				<Skeleton className="h-4 w-20" />
				<div className="relative">
					<Skeleton className="h-12 w-full" />
					{/* CVC icon skeleton */}
					<div className="-translate-y-1/2 absolute top-1/2 right-3">
						<Skeleton className="h-5 w-8" />
					</div>
				</div>
			</div>
		</div>

		{/* Country and Postal code fields skeleton */}
		<div className="grid grid-cols-2 gap-4">
			<div className="space-y-2">
				<Skeleton className="h-4 w-16" />
				<div className="relative">
					<Skeleton className="h-12 w-full" />
					{/* Dropdown arrow skeleton */}
					<div className="-translate-y-1/2 absolute top-1/2 right-3">
						<Skeleton className="h-3 w-3" />
					</div>
				</div>
			</div>
			<div className="space-y-2">
				<Skeleton className="h-4 w-20" />
				<Skeleton className="h-12 w-full" />
			</div>
		</div>
	</div>
);
